module.exports = __webpack_public_path__ + "media/images/icons/filled/google-plus-square-0b89a4a599a6432cc3fd1ed3d7c26aee.svg";